var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"action-bar__btn",attrs:{"round":"","depressed":"","color":"accent"},on:{"click":_vm.openDialog}},[_vm._v("\n    "+_vm._s(_vm.$t((_vm.namespace + ".newProject")))+"\n  ")]),_c('NewProjectDialog',{attrs:{"visible":_vm.newProjectDialog},on:{"close":function (reload) {
      _vm.closeDialog()

      if (reload) {
        this$1.$emit('updateView')
        this$1.$emit('change')
      }
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }